import React from 'react'
import Header from '../include/Header'
// import { Link } from 'react-router-dom'
import Footer from '../include/Footer'

function RefundPolicy() {
    return (
        <>
            <Header />
            <div className="page-header bg-section">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-12">

                            <div className="page-header-box">
                                <h1 className="wow fadeInUp" data-cursor="-opaque">Refund & Cancellation Policy</h1>
                               {/*  <nav className="wow fadeInUp" data-wow-delay="0.2s">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to="/">home</Link></li>
                                        <li className="breadcrumb-item active" aria-current="page">Refund & Cancellation Policy</li>
                                    </ol>
                                </nav> */}
                            </div>

                        </div>
                    </div>
                </div>
            </div>



            <div className="cta-box">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">

                            <div className="cta-box-content">

                                <div className="section-title">
                                    {/* <h3 className="wow fadeInUp">Get in touch</h3> */}
                                    <p className="wow fadeInUp" data-wow-delay="0.2s" data-cursor="-opaque">

                                        To the fullest extent permitted by applicable laws, all subscription payments made on our platform are final and non-refundable. This applies regardless of whether the services have been accessed or utilized.
                                        Once a subscription is purchased, it remains valid for the entire duration of the selected billing cycle (“Subscription Term”). If you choose to cancel your subscription at any time, the cancellation will only prevent future renewals. Your current subscription will continue until the end of the active Subscription Term.
                                        We do not provide refunds, credits, or adjustments for:
                                        <ul>
                                            <li>Partially used subscription periods</li>
                                            <li>Unused or unwatched content</li>
                                            <li>Early cancellation during an active billing cycle</li>
                                        </ul>
                                        Any request to modify or change your subscription plan will be processed <b>after the completion of your current Subscription Term. </b>The updated plan will only become effective once the existing billing cycle ends and the applicable payment for the new plan is successfully completed.

                                    </p>
                                    <h5 className="wow fadeInUp mt-5" data-wow-delay="0.2s" data-cursor="-opaque"><span>Return & Shipping Policy</span></h5>
                                    <p className="wow fadeInUp" data-wow-delay="0.2s" data-cursor="-opaque">
                                        As we offer <b>digital services and content,</b> there are no physical products involved. Therefore:
                                        <ul>
                                            <li>We do not provide returns, replacements, or exchanges</li>
                                            <li>No shipping or delivery is applicable</li>
                                            <li>All services are delivered and accessed online through our platform</li>

                                        </ul>
                                        Once subscribed, users can access the available content digitally as per their selected plan.

                                        {/* We're just a message away
                                        from <span>smarter solutions</span> */}

                                    </p>

                                </div>

                                <div className="cta-section-shape">
                                    <img src="/assets/images/section-bg-shape-1.png" alt="" />
                                </div>
                            </div>

                        </div>


                    </div>
                </div>
            </div>


            <Footer />


        </>
    )
}

export default RefundPolicy
